const PREFIX = "@HIGHGROUND_GLOBAL_";

export const ACTION_CENTRE = `${PREFIX}ACTION_CENTRE`;
